<template>
  <div id="fileUploadRegi" class="modal fade custom" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content containers">
        <div class="modal-header" >
          <section>
            <div class="col-xs-12 p-16 d-flex align-items-center justify-content-between header-wrapper">
              <div class="share-link-text modal-header-title font-20">{{ $t('AttachFile') }}</div>
              <img
                class="pr-5 cursor-pointer"
                src="/static/images/icons/ul_close_icon.svg"
                alt="file-upload-close-x"
                data-dismiss="modal"
                @click="reset"
              />
            </div>
          </section>
        </div>
        <div class="modal-body" id="attachments_table">
           <div class="row m-0  pr-17">
               <div class="col-md-12 col-xs-12 col-sm-12 p-0">
                  <p class="support_message m-0">{{$t('addAttachmentBelow')}}</p>
                      <div class="upload-area" @drop.prevent.stop="getDroppedFile" @dragover.prevent.stop="onDragOver" :class="!uploadedFiles.length?'mb-500':''">
                        <div class="notify_message">
                          <ul  class="instructions">
                                <li>
                                  {{ $t('fileUploadMessage1') }}
                                </li>
                                <li>
                                  {{ $t('fileUploadMessages') }}
                                </li>
                                <li>
                                  {{ $t('fileTypeMessage') }}
                                </li>
                                <li>
                                  {{ $t('fileUploadMessage5') }}
                                </li>
                          </ul>
                            </div>
                            <div class="col-xs-12 col-sm-12 p-0 mb-8">
                              <input type="file" multiple ref="fileListUploaded" accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .xlsx, .xls, .ppt, .pptx" id="uploadFiles" class="hidden" @change="filesChange"/>
                              <div class="d-flex mt-20 ml-24">
                                <button for="uploadFiles" class="btn emergo-btn emergo-secondary-button d-flex align-center" @click="openFileUpload">
                                  {{ $t('upload') }}
                                </button>
                              </div>
                            </div>
                          </div>
                </div>
                 <div   class="col-xs-12 col-sm-12 col-md-12 p-0 pl-8" v-if="uploadedFiles && uploadedFiles.length">
                        <div class="col-xs-12 col-sm-12 col-md-12 p-0"><hr class="lower-line-inside " /></div>
                      <div class="files-main">
                      <div class="attachments-label">{{$t('FilesAttachedLabel')}}:</div>
                       <div class="col-xs-12 col-sm-12 col-md-12 p-0" >
                        <div>
                        <table class="table table-responsive registration-data" id="attachmentsDataList" >
                            <tr style="background-color: #E6E6E6; !important;">
                              <th style="width:80%" >
                                <div class="tableHeader cursor-pointer" @click="fileNameArrow = (-fileNameArrow), sortFileNames('name', fileNameArrow)">
                                  <div class="header-ellipsis header-title" :title="$t('FilesAttachedLabel')">{{$t('FilesAttachedLabel')}}</div>
                                  <div class="arrow" :class="fileNameArrow === 1 ? 'down-arrow ' : 'up-arrow '"></div>
                                </div>
                              </th>
                              <th></th>
                            </tr>
                          <tbody ref="tbodyBox" >
                            <tr class="viewRegistration"
                            :class="index%2===0?'table_data_part1':'table_data_part2'"
                            v-for="(file, index) in uploadedFiles" :key="index">
                            <td  class="ellipsis files-data" style="width:50%">
                             <div class=" ellipsis pl-0" :title="file.name">{{file.name}}</div>
                            </td>
                              <td class="ellipsis edit-icons ">
                                <div class=" d-flex justify-content-end pr-32" > <div>
                                    <button class="btn btn-delete-file p-0 d-flex align-items-center" id="ptb-0" @click="checkfile(file)">
                                    <img src="/static/images/icons/Trash.svg" class="delete-images pr-4" />{{$t('delete')}}</button>
                                    </div></div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        </div>
                      </div>
                      </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
          <section>
            <div class="col-xs-12 p-0 d-flex justify-content-end col-gap-16">
              <button type="button" class="btn emergo-btn emergo-secondary-button" data-dismiss="modal" @click="reset">
                {{ $t('cancel') }}
              </button>
              <button type="button" class="btn emergo-btn emergo-primary-button" @click="uploadToBlob()" :disabled="!uploadedFiles.length">
                {{ $t('submit') }}
              </button>
            </div>
          </section>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import ElButton from 'element-ui/packages/button/src/button.vue';
import $ from 'jquery';
import { uploadRegiAttachments } from '../../apis/fileUploadDownload';
import ExcelInfoPopover from './ExcelInfoPopover.vue';
import DownloadRegAttachment from './mixins/downloadRegAttachment';
import Loader from './Loader.vue';
import EventBus from '../../utils/event-bus';

export default {
  mixins: [DownloadRegAttachment],
  props: ['regiId', 'type', 'record_attachments', 'revision'],
  components: {
    ElButton,
    ExcelInfoPopover,
    Loader
  },
  data() {
    return {
      requestHeader: {},
      errorExtensions: '',
      acceptedExtensions: ['pdf', 'doc', 'docx', 'jpg', 'tif', 'gif', 'png', 'xlsx', 'xls', 'ppt', 'pptx'],
      uploadedFiles: [],
      currentStatus: null,
      uploadFieldName: 'file',
      duplicateFiles: [],
      removeFiles: 0,
      oldAttachments: '',
      urlData: '',
      newAttachedFiles: [],
      isNotConaints: '',
      remains: [],
      isDuplicate: false,
      loaderStatus: false,
      fileNameArrow: 1,
    };
  },
  created() {
    this.$parent.$on('resetFileUpload', this.reset);
  },
  computed: {
    disableUpload() {
      if (!this.remains.length && this.uploadedFiles.length) {
        return false;
      }
      if (this.dataAttachment && this.newAttachedFiles.length) {
        const newAttachmentsArr = this.newAttachedFiles[0].attachment
          ? this.newAttachedFiles[0].attachment.split(';')
          : [];
        if (this.dataAttachment.length !== newAttachmentsArr.length) return false;
      }
      return true;
    }
  },
  methods: {
    openFileUpload() {
      $('#uploadFiles').click();
    },
    onDragOver(event) {
      event.dataTransfer.dropEffect = 'copy';
    },
    getDroppedFile(event) {
      const selectedFile = [...event.dataTransfer.files];
      this.filesUploaded(selectedFile);
    },
    filesChange() {
      this.filesUploaded([...this.$refs.fileListUploaded.files]);
    },
    filesUploaded(fileList) {
      const fileInfo = this.uploadedFiles.filter((item) => fileList.find((f) => f.name.toLowerCase() === item.name.toLowerCase()));
      if (fileInfo.length) {
        fileList = fileList.filter((item) => fileInfo.every((f) => f.name.toLowerCase() !== item.name.toLowerCase()));
        this.$refs.fileListUploaded.value = '';
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Alguns nomes de arquivo já existem' : 'Some file names already exist',
          group: 'custom-notification'
        });
      }
      fileList.forEach((file) => {
        const filename = file.name.substring(0, file.name.lastIndexOf('.'));
        const extN = file.name.split('.').pop();
        if (!(
          /^.*[A-Za-z0-9].*/.test(filename) &&
            !/[;#,^'"]/gi.test(filename) &&
            this.acceptedExtensions.indexOf(extN.toLowerCase()) !== -1
        )) {
          file.error = true;
          this.$refs.fileListUploaded.value = '';
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Formato Inválido' : 'Invalid format',
            group: 'custom-notification'
          });
        }
      });
      if (!fileList.length) return;
      fileList = fileList.filter((file) => !file.error);
      this.uploadedFiles = this.uploadedFiles.concat(...fileList);
      this.$refs.fileListUploaded.value = '';
    },
    sortFileNames(type, direction) {
      if (direction === 1) this.uploadedFiles.sort((a, b) => (a[type] > b[type] ? -1 : 1));
      else {
        this.uploadedFiles.sort((a, b) => {
          const nameA = a[type].toUpperCase(); // ignore upper and lowercase
          const nameB = b[type].toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        });
      }
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    checkfile(file) {
      this.uploadedFiles = this.uploadedFiles.filter((each) => each.name !== file.name);
      this.$refs.fileListUploaded.value = '';
    },
    async uploadToBlob() {
      this.loaderStatus = true;
      if (this.record_attachments && this.record_attachments.length + this.uploadedFiles.length > 20) {
        this.loaderStatus = false;
        this.$refs.fileListUploaded.value = '';
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Máximo de 20 arquivos permitidos!' : 'Max 20 files allowed!',
          group: 'custom-notification'
        });
        return;
      }
      // eslint-disable-next-line no-nested-ternary
      const attachments = this.type === 'test_report_attachments' ? this.test_report_attachments : this.type === 'product_certificate_attachments' ? this.product_certificate_attachments : this.barcode_attachments;
      let attachmentsData = '';
      if (this.record_attachments) {
        this.record_attachments.forEach((item) => {
          attachmentsData = attachmentsData ? `${attachmentsData};${item.attachmentLink}` : item.attachmentLink;
        });
      }
      const formData = new FormData();
      this.uploadedFiles.forEach((item) => {
        formData.append('attachments', item);
      });
      formData.append('revision', this.revision);
      formData.append('registrationId', this.regiId);
      formData.append('attachment_type', this.type);
      const fileUploadRes = await uploadRegiAttachments(formData, this.regiId);
      if (fileUploadRes.status_code === 200) {
        this.loaderStatus = false;
        $('#fileUploadRegi').modal('toggle');
        this.reset();
        EventBus.$emit('updateRecordAttachments', fileUploadRes.revision);
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text:
                this.$i18n.locale === 'Portuguese'
                  ? 'Arquivo(s) carregado(s) com sucesso!'
                  : 'File(s) uploaded successfully!',
          group: 'custom-notification'
        });
      } else if (fileUploadRes.status_code === 500 && attachments.length >= 1000) {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
                this.$i18n.locale === 'Portuguese'
                  ? 'Comprimento do nome do arquivo excedido'
                  : 'File name length exceeded',
          group: 'custom-notification'
        });
      } else {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
                this.$i18n.locale === 'Portuguese'
                  ? 'O upload do(s) arquivo(s) falhou. Tente novamente'
                  : 'File(s) upload failed. Try again',
          group: 'custom-notification'
        });
      }
    },
    reset() {
      this.uploadedFiles = [];
      this.newAttachedFiles = '';
      this.remains = [];
      this.isNotConaints = '';
      $('#fileUploadRegi .modal-body').scrollTop(0);
      this.$refs.fileListUploaded.value = '';
    },
    removeItem(value) {
      this.remains = this.remains.filter((item) => item !== value);
      if (this.remains.length <= 0) {
        this.isNotConaints = '';
      }
    }
  },
  mounted() {
    this.reset();
  }
};
</script>
<style scoped>
ul {
  margin: 0px !important;
  padding-left:13px;
  text-align: left;
}
.pl-8 {
  padding-left: 8px;
}
.mb-500{
  margin-bottom: 400px;
}
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: hidden;
}
.containers {
  max-height: 930px;
}
#attachments_table::-webkit-scrollbar {
  width: 6px;
}
#attachments_table::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
#attachments_table {
  margin-bottom: 12px;
  max-height: calc(80vh - 142px);
  overflow-y: auto;
  overflow-x: hidden;
}
/* ::v-deep .el-icon-close:before{
  content: none !important;
} */

::v-deep .el-icon-close:before {
  content: url('/static/images/icons/emergo_delete.svg');
}
::v-deep .el-icon-document:before {
  content: none !important;
}
.delete-images {
  width: 18px;
  height: 18px;
  padding-right: 2px;
}
 .btn-delete-file {
  background: none;
  color: #C02032 !important;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  }
.files-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 16px 16px !important;
}
.edit-icons{
  padding: 14px 46px 16px 12px !important;
}
.header-hr-outer {
  margin-left: 23px;
  margin-right: 48px;
}
.lower-line-inside {
  border-top: 1px solid #CCCCCD;
  margin: 32px 0px;
}
.attachments-label {
    color:  #333;
    font-family: Open Sans;
    font-size: 18px;
    font-weight: 600;
    padding-bottom: 16px;
}
#attachmentsDataList th .arrow {
  opacity: 1;
}
#attachmentsDataList thead,

#attachmentsDataList tbody,

#attachmentsDataList tr:not(#attachmentsDataList thead tr) {
 display: table;
 width: 100%;
table-layout: fixed;
}
.tableHeader {
  display: flex;
  align-items: center;
  padding:14px 0px 12px 16px;
  column-gap: 7px
  /* justify-content: center; */
}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}
.header-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3e3e3e;
}
.table_data_part1{
  background-color: #FAFAFA;
}
.table_data_part2{
  background-color: #F5F5F5;
}
.mr-0 {
  margin-right: 0px;
}
.hr-line {
  margin: 0px !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.pb-91 {
  padding-bottom: 91px;
}
.emergo-btn {
  padding: 10px 16px;
  font-size: 18px;
  line-height: 24px;
}
.support_message {
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #3E3E3E;
  padding: 8px 0 16px 0px;
}
.upload-area {
  min-height: 206px;
  padding: 24px 16px;
  border-radius: 3px;
  border: 1px solid #d3d3d3;
  margin-left: 8px;
}
.ml-24 {
  margin-left: 24px;
}
.custom .modal-content {
  /* min-height: 600px; */
  min-width: 747px;
  background: #ffffff;
  border-radius: 6px;
  /* margin: auto; */
}
.custom .modal-header {
  background: #ffffff;
  border-bottom: none;
  border-radius: 8px;
  padding: 0px;
  color: #1a1a1a;
  /* background-color: #ffffff;
  border-bottom: none;
  margin: 0px 24px 18px 26px;
  padding: 25px 0px 0px 0px !important; */
}
/* .custom .modal-header .header-title {
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 44px;
  color: #333333;
} */
.custom .modal-header .cancel-x {
  position: absolute;
  right: 26px;
  cursor: pointer;
}

.modal-footer .btn + .btn {
  margin-left: 0px;
}
.custom .modal-footer {
  padding: 16px;
  background-color: #fafaf9;
  border-top: none;
  /* border-radius: 8px; */
}
.modal-body {
  /* display: flex;
  align-items: center;
  justify-content: center;
  text-align: center; */
  padding: 0px 51px 0px 32px !important;
}
.p-40 {
  padding: 0px 0px 40px 0px !important;
}
.modal-body .file-upload-icon {
  padding-top: 48px;
  text-align: center;
  justify-content: center;
}
.blue_outline_upload_button,
.blue_outline_upload_button:hover {
  background-color: #fff;
  border: 1px solid #000000;
  height: 36px;
  max-width: 120px;
  border-radius: 5px;
  padding: 6px 29px 5px 28px;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #000000;
  margin: auto auto 32px auto;
  display: flex;
  align-items: center;
  filter: drop-shadow(4px 4px 10px rgba(0, 0, 0, 0.25));
}
.blue_outline_cancel_button,
.blue_outline_cancel_button:hover {
  background-color: #fff;
  border: 1px solid #000000;
  height: 44px;
  max-width: 122px;
  border-radius: 5px;
  padding: 6px 29px 5px 28px;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  justify-content: center;
  color: #000000;
  display: flex;
  align-items: center;
  filter: drop-shadow(4px 4px 10px rgba(0, 0, 0, 0.25));
}
.blue_save_button,
.blue_save_button:hover,
.blue_save_button:focus {
  background-color: #01518a;
  border: 1px solid #01518a;
  height: 44px;
  max-width: 122px;
  cursor: pointer;
  color: #fff;
  font-size: 18px;
  line-height: 25px;
  padding: 10px 41px 9px 40px;
  font-weight: 600;
  border-radius: 5px;
  opacity: 1 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(4px 4px 10px rgba(0, 0, 0, 0.25));
}
.footer {
  position: absolute;
  bottom: 0%;
  padding-bottom: 24px;
  padding-right: 32px;
  right: 0;
  column-gap: 24px !important;
}
.footer-hr-line {
  position: absolute;
  bottom: 91px;
  padding-left: 32px;
  padding-right: 32px;
}
.footer-hr-line hr {
  margin-top: 0px;
  margin-bottom: 0px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
/* ::v-deep .el-upload-list__item {
  max-width: 80%;
  margin: auto;
} */
::v-deep .el-upload-dragger.is-dragover {
  border: none;
  background-color: transparent;
}

::v-deep .el-upload-dragger {
  height: 180px;
}
::v-deep .el-upload-dragger, .el-upload-dragger:hover {
  border: none;
  border-color: #fff;
}
::v-deep .el-upload-list__item.is-ready .el-icon-close {
  display: inline-block;
  left: 75%;
  top: 4px;
  opacity: 1;
  font-weight: bolder !important;
}
::v-deep .el-upload-list__item.is-success .el-icon-close {
  display: inline-block;
  left: 80%;
  top: 9px;
  opacity: 1;
  font-weight: bolder !important;
}
::v-deep .el-upload-list__item.is-ready {
  max-width: 500px;
  margin: 0px auto 10px auto;
}
::v-deep .el-upload-list__item:hover {
  background-color: transparent !important;
}
/* ::v-deep .el-upload-list__item:first-child{
  margin-top: 32px;
} */
.upload-demo ::v-deep .el-upload-list__item-name {
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #01518A;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  margin: auto auto 10px auto;
  max-width: 70%;
  margin-top: 0px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-name {
  color: #333333;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  margin: auto;
}
::v-deep .el-upload-list__item.is-success {
  background-color: transparent !important;
  max-width: 500px;
  margin: 10px auto auto auto;
}
::v-deep .el-upload-list__item.is-success:hover,
::v-deep .el-upload-list__item.is-success .el-upload-list__item-name:hover {
  color: #333333;
  cursor: pointer;
}
::v-deep .upload-demo input[type='file'] {
  display: none;
}
.el-upload__input {
  display: none;
  background-color: #dcffda;
  padding: 0px;
  border-radius: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.notify_message {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 0px 10px;
}
.color-red {
  color: #b00505;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}
.custom-el-upload-list__item-name {
  color: #409eff;
  cursor: pointer;
  text-align: left;
}
/* .custom-el-upload-list__item {
  background-color: #f5f7fa;
} */
/* .custom-el-icon-close {
  background-color: transparent !important;
  color: #d8212b !important;
  display: inline-block !important;
} */
::v-deep .excel-popover {
  text-align: left;
  left: 2%;
}
::v-deep .el-upload-list__item-name .download-icon {
  font-weight: 700;
  color: #0b3c61;
}
::v-deep .el-upload {
  text-align: left;
}
.attachment-text {
  margin-bottom: 10px;
}
@media screen and (min-width: 768px) {
  .attachment-text {
    text-align: right;
    margin: 0;
  }
  ::v-deep .excel-popover {
    left: 18%;
  }
  .modal-dialog {
      /* width: 1147px; */
      margin: 30px auto;
  }
}
@media screen and (min-width: 992px) {
  ::v-deep .excel-popover {
    left: 45%;
  }
}

.header-wrapper {
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 16px;
}

.modal-header-title {
  line-height: 27px;
  color: #1a1a1a;
  font-size: 20px;
  font-weight: 600;
}
</style>
